Vue.component("FullscreenVideo", {
    mixins: [SceneContentComponentMixin, MediaPathMixin],
    template: `
        <transition name="fadeinvideo">
            <div class="FullscreenVideo__wrapper" v-if="videoplayerready" >
         

                <div class="FullscreenVideo__media">
                   
                
                    <video
                        id="FullscreenVideo__video"
                        :autoplay="autoplay"
                        :controls="controls && !hideUI"
                        :mute="mute"
                        :loop="loop"
                        playsinline
                        webkit-playsinline
                        type="video/mp4"
                        :src="getMediaPath(video.src)"
                        :poster="getMediaPath(image.src)"
                        @contextmenu.prevent=""
                        ref="video"
                        v-if="!isYoutubeVideo && video !== null"
                    ></video>
<!-- 

                    <iframe 
                        id="FullscreenVideo__iframe" 
                        :src="youtube" 
                        @contextmenu.prevent="" 
                        frameborder="0" 
                        v-if="isYoutubeVideo" 
                        allowfullscreen="allowfullscreen"
                        mozallowfullscreen="mozallowfullscreen" 
                        msallowfullscreen="msallowfullscreen" 
                        oallowfullscreen="oallowfullscreen" 
                        webkitallowfullscreen="webkitallowfullscreen"></iframe> -->

                  <!-- TODO: let this component be able to play Iframe content aswell
                        <iframe :src="SOMESRC" 
                            style="" 
                            frameborder="0" 
                            border="0" 
                            scrolling="no" 
                            // How should we build the properties if customs like these are required
                            mozallowfullscreen="1" 
                            webkitallowfullscreen="1" 
                            allowfullscreen="1" 
                            allow="autoplay; fullscreen">
                        </iframe>
                        -->

                        <div class="FullscreenVideo__playbutton" v-if="isVideoPaused" @click="playVideo">▶</div>
                    <div @click="close" class="FullscreenVideo__btnClose" v-if="!hideUI">&times;</div>
                    </div>
            </div>
        </transition>
    `,
    data() {
        return {
            image: '',
            img: "",
            video: '',
            youtube: '',

            // default img directory
            imgDirectory: '',
            videoDirectory: '',

            // Variables that can be set to customize video player component. 
            // These are the default values and can be overwritten in the manifest.
            autoplay: true,
            controls: true,
            mute: false,
            loop: false,
            hideUI: false,

            // Variables for this instance to handle functionality
            videoplayerready: false,
            isVideoPaused: false
        }
    },
    methods: {
        playVideo() {
            // toggle play & pause
            this.isVideoPaused = !this.isVideoPaused;
            if(this.$refs.video.playing) 
                this.$refs.video.stop();
            else 
                this.$refs.video.play();
        }
    },
    computed: {
        isYoutubeVideo() {
            return this.youtube !== ''
        },
        videoURL() {
            // set default background video directory
           return this.getMediaPath(this.video.src);
          // return "assets/video/" + this.video
        },
        imgURL() {
            // set default background img directory
            return this.getMediaPath(this.image.src);
        }
    },
    mounted() {
        // handle intro animation
        this.videoplayerready = true;

        // start/stop video on start if autoplay is enabled
        this.isVideoPaused = !this.autoplay;
    },
})

touchKit.ComponentManager.register("FullscreenVideo", {singleton: true});